import React from "react"
import { Box } from "rebass"

const TH = ({ cssClass, ...props }) => (
  <th style={{ fontWeight: "normal" }}>{props.children}</th>
)

const BwTable = ({ bandwidth, nightGigs }) =>
  bandwidth.length === 0 ? (
    <div />
  ) : (
    <Box style={{ maxWidth: "100%", overflowX: "auto" }}>
      <table
        className="table table-striped table-bordered"
        style={{ padding: 0 }}
      >
        <thead>
          <tr>
            <TH>Date</TH>
            <TH>Total(GB)</TH>
            {nightGigs && <TH>Night</TH>}
            <TH>Down</TH>
            <TH>Up</TH>
          </tr>
        </thead>
        <tbody>
          {bandwidth.map((row, i) => (
            <tr key={i}>
              <td>
                {row.month}/{row.day}
              </td>
              <td>{row.total}</td>
              {nightGigs && <td>{row.exempt}</td>}
              <td>{row.down}</td>
              <td>{row.up}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  )

export default BwTable
